import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { offer } from '../data/offer';

/* Appears once the hero is scrolled past; hides while the offer section is on screen. */
export function StickyOfferBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('top');
    const offerEl = document.getElementById('offer-details');
    let heroOut = false;
    let offerIn = false;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) heroOut = !entry.isIntersecting;
        if (entry.target === offerEl) offerIn = entry.isIntersecting;
      });
      setVisible(heroOut && !offerIn);
    });
    if (hero) observer.observe(hero);
    if (offerEl) observer.observe(offerEl);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-224" data-mp="3vlyrl5z791i0">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 shadow-[0_-10px_30px_rgba(23,63,70,.12)] backdrop-blur" data-id="element-225" data-mp="oonubw2emfq0">
          <div className="mx-auto flex max-w-[1180px] items-center justify-between gap-3 px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 sm:px-8" data-id="element-226" data-mp="knlvvhgba7p3">
            <div className="min-w-0 leading-tight" data-id="element-227" data-mp="1cf1dex30h48g">
              <p className="hidden truncate text-sm font-bold text-petrol sm:block" data-id="element-228" data-mp="1cdqfhdw8yqp9">
                Speech Therapy Ready · Fall Starter Kit
              </p>
              <p className="flex items-baseline gap-1.5" data-id="element-229" data-mp="13leq7vcvd9av">
                <span className="font-display text-[26px] font-extrabold text-petrol" data-id="element-230" data-mp="13jv962je2u81">${offer.price}</span>
                <span className="text-xs font-medium text-slate" data-id="element-231" data-mp="1w2imgvs594yk">{offer.currency}</span>
                <span className="text-[11px] font-medium text-slate sm:text-xs" data-id="element-232" data-mp="1w4bx0m5vo9bu">· Kit + 5 bonuses</span>
              </p>
            </div>
            <a href="#offer-details" className="inline-flex shrink-0 items-center gap-2 rounded-xl bg-coral px-5 py-3 font-display text-lg font-bold uppercase text-white no-underline shadow-[0_5px_0_#8E3526] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-coral-hover active:translate-y-[4px] active:shadow-[0_1px_0_#8E3526]" data-id="element-233" data-mp="20z4uj1uxac8q">
              See the offer
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-234" data-mp="1i7c2parlax2l" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}